import { Grid, Typography } from '@material-ui/core';

const Total = (props) => {
  const { orderItem, classes, totalText } = props;
  return (
    <Grid item container className={classes.itemContainer}>
      <Grid item className="total-text" xs={12} sm={6}>
        <Typography>{totalText}</Typography>
      </Grid>
      <Grid item className="total-value" xs={12} sm={6}>
        <Typography className={classes.totalAmount}>
          {!orderItem.switchTotalAmountDisplayTemplate
            ? orderItem.totalAmountDisplay
            : orderItem.subTotalAmountDisplay}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Total;
